module.exports = __webpack_public_path__ + "static/assets/6963d80bc711731cef82dcfb521c6ce2.svg";